import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { HEADER_BACKGROUND, type ThemeMode } from '../theme/palettes';

const OPTIONS: { value: ThemeMode; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
];

const ThemeModePicker = () => {
  const { mode, colors, setMode } = useTheme();

  return (
    <View style={styles.row}>
      {OPTIONS.map((opt) => {
        const selected = mode === opt.value;
        return (
          <TouchableOpacity
            key={opt.value}
            style={[
              styles.chip,
              {
                borderColor: selected ? colors.button.primary : colors.border,
                backgroundColor: selected ? colors.button.primary : colors.surface,
              },
            ]}
            onPress={() => setMode(opt.value)}
            accessibilityRole="button"
            accessibilityState={{ selected }}
          >
            <Text
              style={[
                styles.chipText,
                {
                  color: selected ? colors.button.primaryText : HEADER_BACKGROUND,
                  fontWeight: selected ? '600' : '400',
                },
              ]}
            >
              {opt.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 8,
  },
  chip: {
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 10,
    borderWidth: 1,
  },
  chipText: {
    fontSize: 15,
  },
});

export default ThemeModePicker;
